let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kOWvR")).then(() => parcelRequire('4uiGD'));